import type { PropsWithChildren } from 'react';
import type { FlexProps, StackProps } from '@chakra-ui/react';
import { Divider, Text, VStack } from '@chakra-ui/react';

import { NabanCard } from './NabanCard';

type Props = {
  title: string;
  contentProps?: StackProps;
};

export const NabanDetailsListCard = ({
  title,
  children,
  contentProps,
  ...props
}: PropsWithChildren<Props & FlexProps>) => (
  <NabanCard {...props}>
    <Text variant='heading4' pt={2} pb={3}>
      {title}
    </Text>
    <Divider borderBottomWidth={2} />
    <VStack gap={4} alignItems='flex-start' py={4} {...contentProps}>
      {children}
    </VStack>
  </NabanCard>
);
